import angular from 'angular';
import { removeNewLineFn } from './util/removeNewLine';

export const loadModule = () =>
  angular.module('app').filter('removeNewLine', function removeNewLine() {
    return removeNewLineFn;
  });
